import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  AUTO_CAL_BALANCE_SHRINKAGE,
  GET_DT_BALANCE_COLUMN,
  GET_DT_BALANCE_ENERGY,
  GET_DT_BALANCE_ZONE,
  GET_DT_BALANCE_ZONE_ENERGY,
  GET_DT_IMBALANCE_ENERGY,
  GET_DT_IMBALANCE_ZONE_ENERGY,
  GET_SHIPPER,
  GET_SHIPPER_BY_BOOKING,
  SAVE_DT_BALANCE_ENERGY,
  SAVE_DT_BALANCE_ZONE_ENERGY,
  SAVE_DT_IMBALANCE_ENERGY,
  SAVE_DT_IMBALANCE_ZONE_ENERGY,
  SAVE_DT_INVENTORY_ZONE_ENERGY,
} from "helpers/url_api_constant";
import { Col, Modal, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { Tab } from "bootstrap";
import TableAccImbalance from "./TableAccImbalance";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf("day");
}

function AccImbalance(props) {
  // console.log(props);
  const dispatch = useDispatch();
  const permission = getPermission();
  // const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateSelected, setDateSelected] = useState(
    moment().add(-1, "day").toDate()
  );
  const [balanceShipper, setBalanceShipper] = useState([]);
  const [mergeData, setMergeData] = useState([]);
  const [dateSelect, setDateSelect] = useState(
    moment().add("days", -1).toDate()
  );
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "SHIPPER_NAME",
      text: "",
      headerAlign: "center",

      align: "center",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "12px",
        width: "40px",
      },
      style: { width: "40px" },
    },
  ]);

  const [zoneList, setZoneList] = useState([]);
  const [shipperSsList, setShipperSsList] = useState([]);
  // const [dateSelected, setDateSelected] = useState(moment().add(-1, 'day').toDate());

  // const getColumn = () => post(GET_DT_BALANCE_COLUMN, {});
  const getBalanceZone = () => post(GET_DT_BALANCE_ZONE, {});
  const getSystemShipper = () => post(GET_SHIPPER, {});
  const getSystemShipper2 = () =>
    post(GET_SHIPPER_BY_BOOKING, {
      LOAD_DATE: moment(dateSelected).format("YYYY-MM-DD"),
    });

  const [columnTable, setColumnTable] = useState([
    {
      // "PID": "b6528e52-74da-4710-87bb-e64a33b091fe",
      BALANCECOLUMN_ORDER: 1,
      BALANCECOLUMN_NAME: "Acc. Imbalance",
      // "BALANCECOLUMN_DESC": "FUEL",
      BALANCECOLUMN_SHOW: true,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
      // "CREATE_USER": "test",
      // "CREATE_DATE": "2022-02-11T14:28:40.457",
      // "UPDATE_USER": "test",
      // "UPDATE_DATE": "2022-02-28T14:14:56.62"
    },
  ]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const formatNumber = (cellContent, row) => {
    return <>{numberFormat(cellContent, 2)}</>;
  };

  const addHeaderTable = () => {
    $(`.accimbalance-table-header`).remove();

    let thead = document
      .getElementById(`accimbalance-table`)
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML = `<th class="accimbalance-table-header" colspan="1" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;width:40px" ,">Shipper</th>`;
    columnTable.map(row => {
      tr.innerHTML += `<th class="accimbalance-table-header" colspan="${zoneList.length}" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px">${row.BALANCECOLUMN_NAME}</th>`;
    });

    thead.prepend(tr);
  };

  //   const ButtonAction = (cellContent, row) => {
  //     return (
  //       <div>
  //         {permission.eBSG && (
  //           <>
  //             <button
  //               type="button"
  //               className="btn btn-secondary me-2"
  //               onClick={() => {}}
  //             >
  //               Refresh
  //             </button>
  //             <button
  //               type="button"
  //               className="btn btn-success me-2"
  //               onClick={() => {
  //                 handleSaveDataByRow(row);
  //               }}
  //             >
  //               Save
  //             </button>
  //           </>
  //         )}
  //       </div>
  //     );
  //   };

  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      // console.log(modelDeviceList)
      modelDeviceList.map(obj => {
        columnTable.map(objColumn => {
          zoneList.map(objZone => {
            data.push({
              ...obj[
                `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                )
              ],
              IMBALANCE_DATA:
                obj[
                  `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                    ".",
                    "_"
                  )
                ],
            });
          });
        });
      });
      // console.log(data)

      let res = await post(SAVE_DT_IMBALANCE_ZONE_ENERGY, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        generateRow();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const getBalanceShipperData = async () => {
    let shipper = await getBalanceShipper();
    let shipperList = [];
    shipper = shipper.data.shipperDataList;
    // console.log(shipper,sysShipper)
    shipper.map(row => {
      let mapShipper = shipperSsList.find(
        obj =>
          obj.SHIPPER_NAME.trim().toLowerCase() ==
            row.SHOW_BOOING_VALUE.trim().toLowerCase() ||
          obj.CONTACT_CODE.trim().toLowerCase() ==
            row.SHIPPER_CODE.trim().toLowerCase()
      );
      if (mapShipper) shipperList.push(mapShipper);
    });
    // console.log(shipperList);
    setBalanceShipper(shipperList);
  };

  // const manualRefresh = async () => {
  //   dispatch(loadingAction.showLoading());
  //   try {
  //     let res = await post(AUTO_CAL_BALANCE_SHRINKAGE, {
  //       // BALANCE_DATE: "01-01",
  //       BALANCE_DATE: moment(dateSelect).format("YYYY-MM-DD"),
  //       FLAG_AUTO_CAL: 0,
  //     });
  //     // console.log(res);
  //     if (res.resultCode == 200) {
  //       dispatch(messageAction.showMessage("Refresh Success"));
  //       generateRow();
  //     } else {
  //       dispatch(messageAction.showMessage(res.resultDescription));
  //     }
  //   } catch (error) {
  //     dispatch(messageAction.showMessage(error.message));
  //   }
  //   dispatch(loadingAction.hideLoading());
  // };

  const generateRow = async () => {
    // console.log('test')
    dispatch(loadingAction.showLoading());
    try {
      let [IMBALANCE_ENERGY, IMBALANCE_ZONE_ENERGY, IMBALANCE_ENERGY_ALL] =
        await Promise.all([
          post(GET_DT_IMBALANCE_ENERGY, {
            IMBALANCE_YEARS: moment(dateSelected).format("YYYY-MM-01"),
          }),
          post(GET_DT_IMBALANCE_ZONE_ENERGY, {
            START_DATE: moment(dateSelected)
              .startOf("month")
              .format("YYYY-MM-01"),
            END_DATE: moment(dateSelected).endOf("month").format("YYYY-MM-01"),
          }),
          post(GET_DT_IMBALANCE_ENERGY, {
            IMBALANCE_DATE: moment(dateSelected)
              .startOf("month")
              .format("YYYY-MM-01"),
            IMBALANCE_TO_DATE: moment(dateSelected)
              .endOf("month")
              .format("YYYY-MM-01"),
          }),
        ]);
      // console.log(IMBALANCE_ENERGY);
      // console.log(IMBALANCE_ZONE_ENERGY);
      // console.log(IMBALANCE_ENERGY_ALL);

      let mapData = IMBALANCE_ZONE_ENERGY.data.dtImbalanceZoneEnergyList.map(
        objZoneEnergy => {
          let obj = IMBALANCE_ENERGY_ALL.data.dtImbalanceEnergyList.find(
            objBalanceEnergy =>
              objBalanceEnergy.PID == objZoneEnergy.IMBALANCEENERGY_PID
          );
          //  console.log(obj)
          if (obj) {
            objZoneEnergy.IMBALANCESHIPPER_PID = obj.IMBALANCESHIPPER_PID;
            // objZoneEnergy.BALANCECOLUMN_PID = obj.BALANCECOLUMN_PID;
            objZoneEnergy.IMBALANCE_MONTH = obj.IMBALANCE_MONTH;
          }
          // console.log(objZoneEnergy)
          return objZoneEnergy;
        }
      );
      // console.log(mapData);
      setMergeData(mapData);

      let tempBalaneEnergy = [];
      let tempDataList = [];
      let date = moment(dateSelected);
      // console.log(createdBalaneEnergy)
      // console.log(IMBALANCE_ENERGY.data.DtInventoryEnergyList)
      balanceShipper.map((objShipper, index) => {
        //   console.log(objShipper)
        let data = { row: index, SHIPPER_NAME: objShipper.SHIPPER_NAME };
        // console.log(data)
        // console.log(IMBALANCE_ENERGY.data.DtInventoryEnergyList);
        columnTable.map(objColumn => {
          let createdBalaneEnergy =
            IMBALANCE_ENERGY.data.dtImbalanceEnergyList.find(
              row =>
                row.IMBALANCESHIPPER_PID == objShipper.PID &&
                //   row.BALANCECOLUMN_PID == objColumn.PID &&
                row.IMBALANCE_MONTH == date.format("MM")
            );
          //   console.log(createdBalaneEnergy);
          // console.log(`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_"))
          data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")] = {
            PID: "",
            IMBALANCE_YEARS: date.format("YYYY-MM-01"),
            IMBALANCESHIPPER_PID: objShipper.PID,
            // BALANCECOLUMN_PID: objColumn.PID,
            // BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
            IIMBALANCECOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
            IMBALANCE_MONTH: date.format("MM"),
            ...createdBalaneEnergy,
          };
          //   console.log(
          //     data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")]
          //   );
          tempBalaneEnergy.push(
            data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")]
          );
          // tempBalaneEnergy
          // console.log(props.zone)
          // console.log(IMBALANCE_ZONE_ENERGY.data.DtInventoryZoneList)
          zoneList.map(objZone => {
            // console.log(createdBalaneEnergy, BALANCE_ZONE_ENERGY.data.dtBalanceList)
            let createdBalaneZoneEnergy =
              IMBALANCE_ZONE_ENERGY.data.dtImbalanceZoneEnergyList.find(
                row =>
                  row.IMBALANCEZONE_PID == objZone.PID &&
                  row.IMBALANCEENERGY_PID ==
                    (createdBalaneEnergy ? createdBalaneEnergy.PID : false)
              );
            // console.log(createdBalaneZoneEnergy)

            // console.log(createdBalaneEnergy)
            data[
              `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = {
              IMBALANCEENERGY_PID: createdBalaneEnergy
                ? createdBalaneEnergy.PID
                : "",
              IMBALANCE_YEARS: date.format("YYYY-MM-01"),
              IMBALANCESHIPPER_PID: objShipper.PID,
              //   BALANCECOLUMN_PID: objColumn.PID,
              //   BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
              IIMBALANCECOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
              IMBALANCE_MONTH: date.format("MM"),
              PID: "",
              IMBALANCEZONE_PID: objZone.PID,
              IMBALANCEZONE_ORDER: objZone.BALANCEZONE_ORDER,
              IMBALANCEZONE_NAME: objZone.BALANCEZONE_ALIAS,
              IMBALANCE_DATA: "",
              ...createdBalaneZoneEnergy,
            };

            data[
              `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = createdBalaneZoneEnergy
              ? createdBalaneZoneEnergy.IMBALANCE_DATA
              : 0;
          });
        });
        // console.log(data)
        tempDataList.push(data);
      });
      //   console.log(tempBalaneEnergy);
      tempBalaneEnergy = tempBalaneEnergy.filter(row => row.PID == "");
      // console.log(tempBalaneEnergy);
      if (tempBalaneEnergy.length > 0) {
        // console.log(tempBalaneEnergy);
        if(permission.eOTH){
        let res = await post(SAVE_DT_IMBALANCE_ENERGY, tempBalaneEnergy);
        generateRow();
        }
      }
      // console.log(tempDataList)
      setModelDeviceList(tempDataList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // console.log(dataList)
  };

  const getBalanceShipper = () =>
    post(GET_SHIPPER_BY_BOOKING, {
      LOAD_DATE: moment(dateSelected).format("YYYY-MM-DD"),
    });

  useEffect(() => {
    // moment(dateSelected).isSame(new Date(), "month")
    //   ? setDateSelect(moment().add("days", -1).toDate())
    //   : setDateSelect(moment(dateSelected).endOf("month").toDate());
    // setDateSelect()
    addHeaderTable();
    getTableData();
  }, [dateSelected]);
  useEffect(() => {
    getBalanceShipperData();
  }, [dateSelected]);
  useEffect(() => {
    renderColumn();
  }, [zoneList, columnTable]);
  useEffect(() => {
    generateRow();
    // console.log(balanceShipper);
  }, [balanceShipper]);
  useEffect(() => {
    addHeaderTable();
    if (columnRenderList.length > 1) {
      // console.log(2)
      getBalanceShipperData();
    }
  }, [columnRenderList]);
  const renderColumn = () => {
    let addColumn = [
      ...columnTable
        .sort((a, b) =>
          a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
            ? 1
            : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.BALANCECOLUMN_SHOW == true || obj.BALANCECOLUMN_SHOW == "true"
        )
        .map(objColumn => {
          return zoneList
            .sort((a, b) =>
              a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
                ? 1
                : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
                ? -1
                : 0
            )
            .map(objZone => ({
              dataField:
                `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                ),
              formatter: formatNumber,
              text: objZone.BALANCEZONE_ALIAS,
              headerAlign: "center",
              editable: true,
              align: "center",
              headerStyle: {
                backgroundColor: colorOption[2].label,
                fontSize: "10px",
                width: "20px",
              },
              style: { width: "25px", cursor: "pointer" },
              editorStyle: () => {
                return { height: "25px" };
              },
              classes: (cell, row, rowIndex, colIndex) => {
                let className = "";
                if (objColumn.STATUS_FLAG != 0) className += "from-source";
                if (objColumn.STATUS_FLAG == 1) className += " pmis";
                if (objColumn.STATUS_FLAG == 3) className += " gqms";
                return className;
              },
              validator: (newValue, row, column, done) => {
                setTimeout(() => {
                  if (isNaN(newValue)) {
                    return done({
                      valid: false,
                      message: "Should be numeric",
                    });
                  }
                  return done();
                }, 0);
                return {
                  async: true,
                };
              },
            }));
        }),
    ];
    let data = [];
    addColumn.map(array => {
      array.map(obj => data.push(obj));
    });
    // console.log(data)
    setColumnRenderList([
      {
        dataField: "SHIPPER_NAME",
        text: "",
        headerAlign: "center",

        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          fontSize: "12px",
          width: "20px",
        },
        style: { width: "20px" },
      },
      ...data,
      //   {
      //     dataField: "Action",
      //     text: "Action",
      //     headerAlign: "center",
      //     editable: false,
      //     align: "center",
      //     headerStyle: {
      //       backgroundColor: "#556ee6",
      //       width: "10%"
      //     },
      //     style: { width: "10%" },
      //     isDummyField: true,
      //     formatter: ButtonAction,
      //   },
    ]);
  };

  const getTableData = async () => {
    // console.log(1);
    try {
      let [zone, shipperMaster, sysShipper2] = await Promise.all([
        // getColumn(),
        getBalanceZone(),
        getSystemShipper(),
        getSystemShipper2(),
      ]);

      // console.log(col);
      // console.log(zone);
      // console.log(shipperMaster);
      // console.log(sysShipper2);

      let sysShipper = sysShipper2.data.shipperDataList.map(row => {
        let temp = shipperMaster.data.customerList.find(
          obj => obj.CONTACT_CODE == row.SHIPPER_CODE
        );

        return {
          SHIPPER_NAME: row.SHIPPER_NAME,
          PID: temp?.PID,
          CONTACT_CODE: row.SHIPPER_CODE,
        };
      });
      // console.log(sysShipper,sysShipper2)
      setShipperSsList(sysShipper);

      // setColumnList(
      //   col.data.dtBalanceColumnList
      //     .sort((a, b) =>
      //       a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
      //         ? 1
      //         : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
      //           ? -1
      //           : 0
      //     )
      //     .filter(row => row.BALANCECOLUMN_SHOW == true)
      // );

      setZoneList(
        zone.data.dtBalanceList
          .sort((a, b) =>
            a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
              ? 1
              : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
              ? -1
              : 0
          )
          .filter(row => row.BALANCEZONE_SHOW == true)
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Col sm="12">
        <div className="d-flex justify-content-end mb-2">
          <h5>Acc Imbalance</h5>
        </div>
        <div>
          <Row>
            <Col sm="5">
              <div style={{ width: "150px" }}>
                {/* <h5> Data Month : </h5> */}
                <DatePicker
                  style={{ width: 200, marginLeft: 0 }}
                  defaultValue={moment(dateSelected)}
                  format={"MMMM YYYY"}
                  onChange={(date, dateString) => {
                    if (date != null) {
                      setDateSelected(date.toDate());
                    }
                  }}
                  picker="month"
                  disabledDate={disabledDate}
                />

                {/* <Flatpickr
                  className="form-control d-block custom-date-picker"
                  placeholder="Select Date"
                  options={{
                    altInput: true,
                    altFormat: "d/m/Y",
                    // altFormat: "F Y",
                    dateFormat: "d/m/Y",
                    maxDate: moment(dateSelected).isSame(new Date(), "month")
                      ? moment().add("days", -1).toDate()
                      : moment(dateSelected).endOf("month").toDate(),
                    minDate: moment(dateSelected).startOf("month").toDate(),
                  }}
                  onChange={value => {
                    setDateSelect(value[0]);
                  }}
                  value={dateSelect}
                /> */}
              </div>
            </Col>
            <Col
              sm="7"
              className="d-flex align-items-center justify-content-end"
            >
              {permission.eOTH && (
                <>
                  {/* <button
                    type="button"
                    className="btn btn-info"
                    
                    onClick={() => {
                      dispatch(
                        confirmAction.showConfirm(
                          "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                          () => {
                            manualRefresh();
                          }
                        )
                      );
                    }}
                  >
                    <i className="mdi mdi-cloud-refresh fa-lg"></i>&nbsp;
                    Refresh Manual
                  </button> */}

                  <button
                    type="button"
                    className="btn btn-success ms-2"
                    onClick={handleSaveData}
                  >
                    <i className="bx bx-save"></i>&nbsp; Save
                  </button>
                </>
              )}
            </Col>
          </Row>
        </div>

        <>
          <div className="mt-2">
            <Col sm="6">
              <BootstrapTable
                id="accimbalance-table"
                keyField="SHIPPER_NAME"
                data={modelDeviceList}
                columns={columnRenderList}
                headerClasses="header-style"
                rowStyle={rowStyle}
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                  onStartEdit: (oldValue, newValue, row, column) => {
                    $(
                      "#accimbalance-table .form-control.editor.edit-text"
                    ).bind("enterKey", function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    });
                    $(
                      "#accimbalance-table .form-control.editor.edit-text"
                    ).keypress(function (e) {
                      if (e.keyCode == 13) {
                        $(this).trigger("enterKey");
                      }
                    });
                  },
                  afterSaveCell: (oldValue, newValue, row, column) => {
                    // console.log(oldValue,newValue, row, column)
                  },
                })}
              />
            </Col>
          </div>

          <hr />
        </>
      </Col>

      {balanceShipper.map(item => (
        <TableAccImbalance
          key={item.PID}
          data={mergeData.filter(row => row.IMBALANCESHIPPER_PID == item.PID)}
          dateSelected={dateSelected}
          column={columnTable}
          zone={zoneList}
          shipper={item}
        />
      ))}
    </>
  );
}
const rowStyle = (row, rowIndex) => {
  const style = {};

  style.color = "white";

  return style;
};

export default AccImbalance;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

AccImbalance.propTypes = {
  t: PropTypes.any,
  // dateSelected: PropTypes.any,
  // column: PropTypes.any,
  // zone: PropTypes.any,
  // shipper: PropTypes.any,
  // yearSelected: PropTypes.any,
};
